/**
 * A tela é de celular? (`C-17`, abaixo de 768 px — a mesma linha do `md:` do Tailwind.)
 *
 * Para o que não dá para resolver só com CSS: a fila da SENATRAN e o comparativo viram
 * cartões no celular, e renderizar os dois (tabela e cartões) e esconder um por classe
 * dobraria o DOM — e cada linha teria dois checkboxes com o mesmo nome. Fora de um navegador
 * (testes, jsdom sem `matchMedia`), a resposta é "não": a mesa é o padrão.
 */
import { useEffect, useState } from "react";

const CONSULTA = "(max-width: 767.98px)";

function consultar(): boolean {
  return typeof window !== "undefined" &&
    typeof window.matchMedia === "function"
    ? window.matchMedia(CONSULTA).matches
    : false;
}

export function useCelular(): boolean {
  const [celular, definirCelular] = useState(consultar);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const lista = window.matchMedia(CONSULTA);
    const mudou = () => definirCelular(lista.matches);
    lista.addEventListener("change", mudou);
    return () => lista.removeEventListener("change", mudou);
  }, []);
  return celular;
}
